import React from 'react'
import { Routes as Router, Route, Navigate } from "react-router-dom"
import BaseLayout from '@/layouts/baseLayout/BaseLayout'
import Home from '@/views/home/Home'

const Routes: React.FC = () => {
  return (
    <Router>
      <Route path="/" element={<BaseLayout />}>
        <Route path="/" element={<Home />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Router>
  )
}

export default Routes
